import React from 'react';
import { truncateDescription } from './SchemaOrg/utils/description';
import { getImage } from './SchemaOrg/utils/image';
import { markdownToPlainText } from './SchemaOrg/utils/markdown';
import { Helmet } from '../../modules/foundation/components/HelmetProvider';
import { ImagesPropType } from '../../services/proptypes';
import { getImageSrc } from '../../utils/images';
var defaultProps = {
  images: [],
  description: '',
  title: '',
  truncateDescription: false,
  ogTitle: '',
  ogDescription: '',
  ogImage: null,
  ogType: 'website',
  ogUrl: ''
};
export default function SEO(_ref) {
  var businessName = _ref.businessName,
    pageName = _ref.pageName,
    description = _ref.description,
    title = _ref.title,
    truncateDescriptionProp = _ref.truncateDescription,
    images = _ref.images,
    ogTitle = _ref.ogTitle,
    ogDescription = _ref.ogDescription,
    ogType = _ref.ogType,
    ogImage = _ref.ogImage,
    ogUrl = _ref.ogUrl;
  var imageSrc = getImageSrc(getImage(images));
  var finalDescription = truncateDescriptionProp ? truncateDescription(description) : description;
  var finalTitle = title || "".concat(pageName, " | ").concat(businessName);
  var finalOgTitle = ogTitle || finalTitle;
  var finalOgDescription = ogDescription || finalDescription;
  var finalOgImage = ogImage || {
    url: imageSrc
  };
  return /*#__PURE__*/React.createElement(Helmet, {
    title: finalTitle
  }, finalDescription && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: markdownToPlainText(finalDescription)
  }), finalOgTitle && /*#__PURE__*/React.createElement("meta", {
    name: "og:title",
    content: markdownToPlainText(finalOgTitle)
  }), finalOgDescription && /*#__PURE__*/React.createElement("meta", {
    name: "og:description",
    content: markdownToPlainText(finalOgDescription)
  }), finalOgImage && finalOgImage.url && /*#__PURE__*/React.createElement("meta", {
    name: "og:image",
    content: finalOgImage.url
  }), finalOgImage && finalOgImage.url && /*#__PURE__*/React.createElement("meta", {
    name: "og:image:url",
    content: finalOgImage.url
  }), finalOgImage && finalOgImage.url && /*#__PURE__*/React.createElement("meta", {
    name: "og:image:secure_url",
    content: finalOgImage.url
  }), finalOgImage && finalOgImage.alt && /*#__PURE__*/React.createElement("meta", {
    name: "og:image:alt",
    content: finalOgImage.alt
  }), finalOgImage && finalOgImage.type && /*#__PURE__*/React.createElement("meta", {
    name: "og:image:type",
    content: finalOgImage.type
  }), ogType && /*#__PURE__*/React.createElement("meta", {
    name: "og:type",
    content: ogType
  }), ogUrl && /*#__PURE__*/React.createElement("meta", {
    name: "og:url",
    content: ogUrl
  }), businessName && /*#__PURE__*/React.createElement("meta", {
    name: "og:site_name",
    content: businessName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "og:locale",
    content: "en_US"
  }));
}
SEO.defaultProps = defaultProps;